import { computed, inject, Injectable } from '@angular/core';
import { DailyRoute } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { EditedStatus, UpdateCustomEditedRouteBody } from 'src/app/pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.interface';
import { CustomRouteResponseCompleted } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { catchError, finalize, map, of, tap } from 'rxjs';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';
import dayjs from "dayjs";

type RemoveItemArgs = {
  day: number;
  element_id: string | number;
  type: 'point' | 'event';
};

type Result = { is_successful: true } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class RemoveItemFromCustomRouteService {
    private _route = inject(CustomRouteService);

    removeItem(args: RemoveItemArgs) {
        const route = this._route.customRouteData();
        const token = this._route.token();
        
        const ctx = validateRoute(route, token, args?.day);
        if (isNotSuccess(ctx)) 
            return of<Result>(ctx);

        const dayIndex = args.day - 1;
        const dayRoute: DailyRoute = route.dailyRoutes[dayIndex];
        const date = dayjs(dayRoute.date).format('YYYY-MM-DD');

        const found = dayRoute.points?.find(p => p.id === args.element_id);
        if (!found) 
            return of<Result>({ 
                is_successful: false, 
                reason: 'No se ha encontrado el item en la ruta' 
            });
        
        const points: any = dayRoute.points.map(p =>
            (p.id === args.element_id)
                ? {
                    id: p.id,
                    startDate: dayjs(p.startDate).format('YYYY-MM-DDTHH:mm:ss'),
                    title: p.title,
                    status: EditedStatus.DELETED,
                    type: p.type
                }
                : {
                    id: p.id,
                    startDate: dayjs(p.startDate).format('YYYY-MM-DDTHH:mm:ss'),
                    title: p.title,
                    type: p.type
                }
        );

        const payload: UpdateCustomEditedRouteBody = { date, token, points };
        return this._route.updateCustomRouteData(payload).pipe(
            tap((res: CustomRouteResponseCompleted) => {
                this._route.updateDailyRoute(res, dayIndex);
            }),
            map((): Result => ({ 
                is_successful: true 
            })),
            catchError(() =>
                of<Result>({ 
                    is_successful: false, 
                    reason: 'No se pudo actualizar la ruta' 
                })
            )
        );
    }

}